// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-box[data-v-106c86ed] {\n  margin-top: 16px;\n}\n.shop-box[data-v-106c86ed] {\n  margin-top: 15px;\n}\n.vehicle-source[data-v-106c86ed] {\n  margin-top: 21px;\n}\n.right-wrap[data-v-106c86ed] {\n  position: fixed;\n  right: 5%;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 9;\n}", ""]);
// Exports
module.exports = exports;
